export const apiHost = process.env.NODE_ENV === 'production' ? 'https://bioviz-api.herokuapp.com' : 'http://localhost:5000';
export const LEFT = 1;
export const DIAGONAL = 2;
export const UP = 3;
